"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _errorMessage["default"];
  }
});

var _errorMessage = _interopRequireDefault(require("./error-message"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }